import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { blue } from '@material-ui/core/colors/';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import './Table.css'
import api_data from '../data/TableData'

let products = api_data['all_products']


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: blue[800],
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));


export default function CustomizedTables() {
    return (
        <div className="containerTable">
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: '10rem' }} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell align="right">Licença</StyledTableCell>
                            <StyledTableCell align="right">Tipo</StyledTableCell>
                            <StyledTableCell align="right">Validade</StyledTableCell>
                            <StyledTableCell align="right">Hardware</StyledTableCell>
                            <StyledTableCell align="right"></StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {products.map((row) => (
                            <StyledTableRow key={row.licenca}>
                                <StyledTableCell align="right">{row.licenca}</StyledTableCell>
                                <StyledTableCell align="right">{row.tipo}</StyledTableCell>
                                <StyledTableCell align="right">{row.expirate}</StyledTableCell>
                                <StyledTableCell align="right">{row.hardware}</StyledTableCell>
                                <StyledTableCell align="right">
                                    <div>
                                        <IconButton aria-label="delete">
                                            <EditIcon style={{ fontSize: 20 }} />
                                        </IconButton>
                                        <IconButton aria-label="delete">
                                            <DeleteIcon style={{ fontSize: 20 }} />
                                        </IconButton>
                                    </div>
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}